<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="appId">
              <a-input placeholder="请输入appId" v-model="queryParam.appId"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                 <a @click="handleResEdit(record)">自动回复配置</a>
              </a-menu-item>
               <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <wechatConfig-modal ref="modalForm" @ok="modalFormOk"></wechatConfig-modal>
    <wechat-config-message-modal ref="modalMessageForm" @ok="modalFormOk" ></wechat-config-message-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import WechatConfigModal from './modules/WechatConfigModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WechatConfigMessageModal from './modules/WechatConfigMessageModal'

  export default {
    name: "WechatConfigList",
    mixins:[JeecgListMixin],
    components: {
      WechatConfigMessageModal,
      WechatConfigModal
    },
    data () {
      return {
        description: '微信配置管理页面',
        // 表头
        columns: [
          {
            title: '名称',
            align:"center",
            ellipsis: true,
            dataIndex: 'name',
          },
          {
            title: 'appId',
            width:200,
            ellipsis: true,
            align:"center",
            dataIndex: 'appId'
          },
          {
            title: 'appSecret',
            align:"center",
            ellipsis: true,
            width:200,
            dataIndex: 'appSecret'
          },
          {
            title: 'token',
            ellipsis: true,
            width:200,
            align:"center",
            dataIndex: 'token'
          },
          {
            title: '微信消息模版ID',
            align:"center",
            ellipsis: true,
            width:200,
            dataIndex: 'templateId'
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:100,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/management/wechatConfig/list",
          delete: "/management/wechatConfig/delete",
        },
      }
    },
    computed: {
    },
    methods: {
      handleResEdit(record){
        this.$refs['modalMessageForm'].edit(record)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>